import React from 'react';
import { RecoilRoot } from 'recoil';

import Shell from './shell';
import routes from './routes';

import { AutoRefreshingRouter } from 'Components/shared/';

const App = () => (
  <RecoilRoot>
    <AutoRefreshingRouter>
      <Shell routes={routes} />
    </AutoRefreshingRouter>
  </RecoilRoot>
)

export default App;
